import { connect } from 'react-redux'
import { SignIn } from 'components/Auth'
import { signIn } from 'actions/auth'
import { flashSuccess } from 'actions/flash'
import { bindActionCreators } from 'redux'

const mapStateToProps = (state) => ({
  auth: state.auth,
  brand: state.brand
})

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ signIn, flashSuccess }, dispatch)
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SignIn)
